import React, { useState, useEffect, useRef } from 'react';
import { alankaramDataAtom } from '../../state';
import { useRecoilValue } from 'recoil';
import { CLOUD_FRONT_URL } from '../../aws.config';
import Header from '../../components/Header';
declare global {
    namespace JSX {
        interface IntrinsicElements {
            'model-viewer': React.DetailedHTMLProps<
                React.HTMLAttributes<HTMLElement>,
                HTMLElement
            > &
            Partial<any>;
        }
    }
}


const ARView = () => {
    const [isMobileOrIpadPro, setIsMobileOrIpadPro] = useState(false);
    const imageRef = useRef<HTMLImageElement>(null);
    const alankaramData = useRecoilValue(alankaramDataAtom);

    // const { isMobile } = useScreen();

    useEffect(() => {
        function isMobile() {
            try {
                if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
                    return true;
                };
                return false;
            } catch (e) { return false; }
        }

        // Media query for iPads and iPad Pros (both portrait and landscape)
        const isIpadOrIpadPro = window.matchMedia(
            '(min-width: 768px) and (max-width: 1366px) and (-webkit-min-device-pixel-ratio: 2)'
        ).matches;
        // Set state if it's a mobile or tablet device
        setIsMobileOrIpadPro(isIpadOrIpadPro || isMobile());
    }, []);

    useEffect(() => {
        const modelViewer = document.getElementById('model-viewer') as HTMLElement | null;
        const loadingSpinner = document.getElementById('loading-spinner') as HTMLElement | null;
        const waiting = document.getElementById('arTutorialsWaitingContainer') as HTMLElement | null;
        const viewerContainer = document.getElementById('viewer-container') as HTMLElement | null;
        const tutorialOverlay = document.getElementById('tutorial-overlay') as HTMLElement
        const startArBtn = document.getElementById('start-ar-btn') as HTMLElement | null;
        const errorMessage = document.getElementById('error-message') as HTMLElement | null;

        const subErrorMessage = document.getElementById('sub-error-message') as HTMLElement | null;
        const errorDesktop = document.getElementById("error-desktop") as HTMLElement;

        if (isMobileOrIpadPro) {
            const setupARButton = () => {
                setTimeout(() => {
                    if (imageRef.current) {
                        imageRef.current.click();
                    }
                }, 3000);

            };
            // Display loading spinner


            // Handle the 3D model loading
            modelViewer?.addEventListener('load', () => {
                setupARButton();
                // Hide the spinner and show the model viewer container
                if (loadingSpinner) loadingSpinner.style.display = 'none';
                if (waiting) waiting.style.display = 'none';
                if (viewerContainer) viewerContainer.style.display = 'block';
                if (startArBtn) startArBtn.style.display = 'block';

                // Hide the tutorial overlay
                // tutorialOverlay?.style.display = 'none';
            });

            // Handle error in fetching model (you can modify the URL logic for a real model)
            modelViewer?.addEventListener('error', (e: Event) => {

                if (loadingSpinner) loadingSpinner.style.display = 'none';
                if (errorMessage) errorMessage.textContent = `Error loading 3D model: ${e}`;
            });

            // Tutorial flow
            startArBtn?.addEventListener('click', () => {
                // Hide tutorial and enable AR mode
                // tutorialOverlay?.style.display = 'none';
                if (modelViewer) {

                    modelViewer.setAttribute('ar', 'true'); // Enable AR mode
                }
            });

            try {
                const params = window.location.href;
                const filename = params.split('/').pop()


                if (!filename) {
                    if (tutorialOverlay) tutorialOverlay.style.display = "none";
                    if (errorMessage) errorMessage.textContent = "File not found";
                    if (subErrorMessage) subErrorMessage.style.display = "none";
                    if (errorDesktop) errorDesktop.style.display = "block";
                    return;
                }

                const fetchData = async () => {
                    try {
                        // Reference to the document in Firestore
                        if (filename) {
                            if (modelViewer) {
                                const src = `${CLOUD_FRONT_URL}${alankaramData?.companyId}/glb/${filename}.glb`
                                // const src = `https://amardeep-designs-prod.s3.ap-south-1.amazonaws.com/AR-poly9-images/${filename}.glb`
                                // `https://app.poly9.ai/public/6152b4d6f09b840008fe7630/3dProduct/styled-GLTF/cc19fd46-e11a-4385-9616-90c35704fc93/017ad701-e59a-41f5-b250-408db0bd31dd.gltf`
                                modelViewer.setAttribute("src", src);
                                if (viewerContainer) viewerContainer.style.display = "block";
                            }

                        } else {
                            throw new Error("No file URL found in this document.");
                        }
                    } catch (error: any) {
                        if (tutorialOverlay) tutorialOverlay.style.display = "none";
                        if (errorDesktop) errorDesktop.style.display = "block";
                        if (errorMessage) errorMessage.textContent = error.message;
                    }
                };
                fetchData();
            } catch (error) {
                console.error('Error loading config:', error);
            }

            startArBtn?.addEventListener('click', () => {
                if (imageRef.current) {
                    imageRef.current.click();
                }
            });
        }
        if (!isMobileOrIpadPro) {
            tutorialOverlay.style.display = 'none'
            errorDesktop.style.display = "block";
        } else {
            tutorialOverlay.style.display = 'block'
            errorDesktop.style.display = "none";

        }
    }, [isMobileOrIpadPro]);


    return (
        <>
            <Header isIcons={false} isSearchBar={false} />
            <div className="mainContainer">
                <div id="viewer-container" className="viewerContainer">
                    <model-viewer style={{ height: 0, width: 0 }} id="model-viewer" src="" alt="A 3D model" ar auto-rotate camera-controls>
                        <img
                            src={alankaramData?.logo}
                            alt={`${alankaramData?.name} Logo`}
                            ref={imageRef}
                            width={50} height={35}
                            id="ar-btn" slot="ar-button"
                        />
                    </model-viewer>
                </div>
                <div className="message">
                    <div id="error-desktop" className="errorDesktop" >
                        <div className="errorMessage" id="error-message">
                            Sorry, your device does not support this Augmented Reality
                            experience.
                        </div>
                        <div className="subErrorMessage" id="sub-error-message">
                            Try using a more recent device.
                        </div>
                    </div>
                </div>
                <div id="tutorial-overlay" className="tutorialOverlay" style={{ display: "block" }}>
                    <div id="icon-container" className="iconContainer">
                        <svg className="rotateIcon ios" width="100%" height="100%" viewBox="0 0 1000 1000"
                            style={{ maxHeight: "130px", height: "70%" }}>
                            <path fill="#000000" fillOpacity="0.5"
                                d="m 508.77904,25.006964 c -0.33344,0.10005 -0.66688,0.16671 -0.96697,0.43347 v -0.10006 h -1.26705 c -17.35531,4.23463 -36.15772,20.6323 -53.82645,28.89617 -12.94396,7.64333 -25.95461,15.15097 -38.99526,22.64092 11.2501,6.29825 22.50021,12.66587 33.73698,18.9878 20.07281,-11.59054 40.1456,-23.16074 60.20507,-34.75396 15.94154,9.81834 31.89642,19.69836 47.83463,29.5507 11.1334,-6.29892 22.28014,-12.52649 33.42688,-18.79908 -25.51447,-15.83484 -51.1223,-31.49229 -77.04022,-46.47053 -0.96696,0 -2.03396,-0.57351 -3.03426,-0.43347 z m 155.75093,94.441856 v 0 c 0,-0.005 0,0 0,0 z m 0,0 c -5.46167,3.09095 -10.86998,6.0902 -16.30164,9.18415 -5.88847,2.58078 -11.62356,5.77409 -17.26528,9.1838 17.65873,10.90667 35.29745,21.81534 52.94952,32.72134 -17.35197,10.02173 -34.69394,20.14883 -52.05591,30.2229 2.60079,1.44711 5.17157,3.00092 7.65234,4.44536 10.99335,3.92853 11.95365,13.8349 11.37347,24.62253 16.72511,-9.70963 33.44022,-19.4236 50.17534,-29.13691 v 64.82182 c 11.13006,-6.71572 22.34016,-13.30841 33.5803,-19.86674 0,-26.43542 0,-52.85616 -1.03365,-79.20955 -9.7063,-17.11857 -32.85671,-21.31952 -47.38115,-33.73764 -7.21555,-4.42869 -14.47776,-8.85137 -21.69331,-13.25106 z m -330.38428,3.27434 c 0,0 0,0.10006 0.33343,0.13337 0,0 0,-0.10006 0.33344,-0.10006 z m 0.33343,0.13337 c -21.48327,12.44547 -42.85643,25.05233 -63.92621,38.06231 -10.58656,17.59571 -1.26705,40.51305 -4.34132,59.94632 v 25.7422 c 11.09005,6.61235 22.20012,13.14935 33.30681,19.72904 v -64.58075 c 15.78486,9.19181 31.57969,18.3226 47.36451,27.48373 v -20.88405 c 5.16825,-2.99425 10.4332,-6.08285 15.68146,-9.28783 -15.51808,-8.98609 -31.04282,-18.00851 -46.55756,-27.01759 17.44867,-10.02107 34.91734,-20.15784 52.36601,-30.23958 -11.34347,-6.15888 -22.62692,-12.52683 -33.8937,-18.95346 z m 107.34609,121.97595 h -0.46682 c 0,0 0,0.10006 0.33344,0.13338 0,-0.10006 0.33343,-0.10006 0.33343,-0.13338 z m -0.33344,0.13338 c -5.07823,2.8442 -10.1531,5.70241 -15.17797,8.54594 v 21.96972 c 18.77906,10.899 37.55481,21.80399 56.34389,32.70366 v 66.7174 c 5.5817,3.30434 11.25677,6.72272 16.88515,10.02839 5.99183,-3.51307 11.98033,-7.13817 17.97216,-10.64859 v -67.09684 c 17.70542,-10.32716 35.42083,-20.54128 53.1229,-30.80841 v -20.71101 c -5.68172,-3.20097 -11.41348,-6.41028 -17.12856,-9.61526 -18.34561,10.65358 -36.69789,21.31252 -55.05349,31.96343 -18.98581,-11.01069 -37.97495,-22.02606 -56.96408,-33.04843 z m -175.46031,91.89142 c 0,34.19178 0,68.3899 1.03365,102.47098 9.91637,17.65374 34.10043,21.02643 49.19504,33.30686 11.5502,6.51099 23.04704,13.16002 34.54723,19.81539 v -38.69884 c -16.9085,-9.81366 -33.82701,-19.5313 -50.72551,-29.29195 v -67.71703 c -11.19009,-6.60969 -22.3635,-13.26338 -33.54692,-19.88441 z m 468.38318,0 c -11.1034,6.60935 -22.21013,13.16803 -33.32353,19.74637 v 67.35459 c -17.98882,10.38083 -35.98099,20.77002 -53.96649,31.15352 V 494.088 c 28.08858,-16.12758 56.07381,-32.41256 83.55221,-49.36609 10.37317,-17.35397 1.13367,-40.03289 4.23796,-59.23977 V 336.85728 Z M 482.91447,464.70936 v 65.59705 c -17.89214,-10.33249 -35.78094,-20.67299 -53.67308,-31.01515 v 38.92423 c 22.11009,12.72689 44.28687,25.2904 66.68371,37.35643 19.90609,0 34.71061,-18.84576 52.68944,-25.69086 6.40196,-3.82183 12.91729,-7.54463 19.4026,-11.33814 v -38.21767 c -16.72177,9.60394 -33.44356,19.30023 -50.15866,28.94717 v -63.92587 c -5.78178,3.20098 -11.49352,6.3096 -17.24861,9.51192 -5.88514,-3.40972 -11.74025,-6.7224 -17.60872,-10.13211 z" />
                            <path fill="#000000" fillOpacity="1"
                                d="m 229.86964,328.83883 c -17.65926,5.07455 -34.37457,10.64091 -49.96947,16.66209 -40.82181,15.76349 -74.16247,34.60258 -97.749348,56.13783 -23.591278,21.53558 -37.632603,46.31282 -37.632603,72.93796 0,26.62547 14.041325,51.42005 37.632603,72.95497 23.586878,21.53558 56.927538,40.37433 97.749348,56.13782 2.01061,0.7769 4.1217,1.5138 6.16932,2.27404 -0.27342,0.0334 -0.40579,0.0334 -0.68821,0.0667 h -39.38911 c -11.51202,0.26674 -11.51202,17.39564 0,17.64406 h 100.42066 l -32.63486,-56.51627 c -1.61084,-2.9309 -4.74016,-4.69845 -8.08108,-4.56606 -6.69778,0.26674 -10.66773,7.60531 -7.22004,13.35407 l 11.68227,20.21151 c 0,0.0667 -0.0867,0.13337 -0.10673,0.20007 -8.28416,-2.73751 -16.40051,-5.54337 -24.08903,-8.51228 C 146.49133,572.58435 114.86836,554.47249 93.554975,535.0132 72.238893,515.55426 61.45473,495.25339 61.45473,474.56773 c 0,-20.68532 10.784163,-40.96886 32.100245,-60.42847 21.313385,-19.45895 52.936355,-37.57148 92.408385,-52.81215 13.71049,-5.29428 28.41525,-10.21845 43.90429,-14.78384 z m 545.28418,3.53241 v 17.71342 c 11.23146,3.54941 21.99449,7.30256 32.22112,11.25143 39.46936,15.24067 71.09233,33.3532 92.40927,52.81215 21.30813,19.45962 32.11789,39.74314 32.11789,60.42847 0,20.68566 -10.80976,40.98653 -32.11789,60.44548 -21.31694,19.45927 -52.93991,37.57114 -92.40927,52.81213 -2.53911,0.98031 -5.23507,1.90392 -7.83937,2.86088 l 15.59313,12.30276 c 40.04018,-15.62678 72.80386,-34.23346 96.06167,-55.46595 23.58774,-21.53458 37.63173,-46.32949 37.63173,-72.95497 0,-26.62514 -14.04399,-51.40204 -37.63173,-72.93762 -23.59041,-21.53525 -56.9275,-40.37434 -97.75022,-56.13783 -12.09425,-4.67009 -24.93224,-9.02276 -38.28633,-13.12968 z m -200.9966,59.58388 c -17.49871,0 -31.89469,13.58882 -30.58458,53.07089 V 664.3217 l -8.56365,6.40963 c 0,0 -1.43278,-146.0163 -4.27345,-220.82917 -0.69688,-31.34957 -12.10753,-43.45594 -29.20573,-43.45594 h -0.70588 v 0 c -17.79073,0.0177 -28.45846,12.12738 -29.17218,43.45594 l -4.99686,301.33145 -7.11595,-3.54975 v -74.81587 c 0,-14.96124 -22.81049,-12.11738 -31.36005,-9.97638 -12.82388,3.56075 -19.22434,26.36672 -25.6389,46.31615 -2.86821,9.97639 -4.27343,19.9431 -4.27343,29.20593 5.6982,84.07569 44.87468,173.13725 78.36528,227.99735 l 0.70589,8.56362 h 199.49771 c 1.43343,-5.70174 2.13231,-11.40849 4.27257,-17.11023 22.80083,-86.21302 49.16932,-163.87608 49.88304,-243.67715 0,-22.8003 -2.13765,-48.45013 -9.97608,-66.9758 -4.98805,-13.53747 -22.07828,-27.07661 -35.61588,-26.36305 -5.69907,0 -4.99687,5.69874 -4.99687,9.9767 v 58.4292 l -7.84023,6.40996 V 633.668 c 0,-22.80029 -27.07427,-34.90233 -44.88615,-35.61588 -9.97608,0 -13.54377,5.69707 -13.54377,14.24968 v 64.83949 l -7.82259,6.40963 V 443.94034 c 0,-39.6021 -14.62271,-51.85185 -32.11788,-51.98522 z m -276.46737,226.98072 -5.82436,16.30031 c 45.22756,9.0141 94.823,15.10662 147.23711,17.71309 l 0.94762,-16.95486 c -50.69742,-2.56744 -98.64224,-8.47692 -142.36037,-17.05854 z" />
                        </svg>
                    </div>
                    <div id="arTutorialsWaitingContainer" className="arTutorialsWaitingContainer">
                        <div className="spinner" id="loading-spinner" />
                        <div>Preparing the AR experience ...</div>
                    </div>
                    <div className="buttonContainer">
                        <button id="start-ar-btn" className="btn bg-black text-white btn-outline-black mb-3 w-auto mx-auto">
                            Start AR
                        </button>
                    </div>

                </div>
            </div>
        </>
    )
};

export default ARView;
